import { getBackendUrl } from "@Utils";
import axiosWrapper from "@Services/axiosWrapper";

import { setPortalProfilesAction, setCustomModulesAction } from "../reducers/portalSetting";
export const setPortalProfiles = setPortalProfilesAction;

export function getPortalCustomModules() {
  return async (dispatch) => {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/portal/customModuleController`);
    if (responseData.data.status) {
      dispatch(setCustomModulesAction(responseData.data.result));
    }
  };
}

export function getPortalProfiles() {
  return async (dispatch) => {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/portal/getPortalProfiles`);
    if (responseData.status) {
      dispatch(setPortalProfiles(responseData.data.result));
    }
  };
}
